<template>
  
  <b-row v-if="esUro">
    <b-col>
      <b-card
       
        no-body
        :class="{ 'open': visibleBody }"
      >

        <b-card-header
          :class="{ 'collapsed': !visibleBody }"
          :aria-expanded="visibleBody ? 'true' : 'false'"
          role="tab"
          data-toggle="collapse"
          @click="onVisibleBody(!visibleBody)"
          style="padding: 0 1px; color: black; font:45px; cursor: pointer;"
        >
          <span class="lead collapse-title">
            <strong>SEMIOLOGIA UROLOGICA</strong>
          </span>
          <i :class="visibleBody ? 'fas fa-chevron-up' : 'fas fa-chevron-down'"/>
        </b-card-header>

        <b-collapse
          v-model="visibleBody"
          role="tabpanel"
        >
          <b-card-body style="padding: 1.5rem">
            <b-row>
              <b-col>

                <b-card border-variant="light">
                  <b-row 
                    align-v="center"
                  >
                    <b-col class="col-3">Sintomas:</b-col>
                    <b-col>
                      <v-select
                        placeholder="Seleccione una o varias opciones"
                        :options="sintomasOpts"
                        :reduce="option => option"
                        label="text"
                        :multiple="true"
                        taggable
                        @input="newArray => sintomas.selected = onAddNewOpt(newArray)"
                      />
                    </b-col>
                  </b-row>

                  <hr class="my-3">

                  <b-row 
                    v-if="sintomas.selected.some(item => item.value === 'dolores')"
                    class="my-2 ml-1"
                    align-v="center"
                  >
                    <span class="col-3">Dolor:</span>
                    <v-select
                      class="col"
                      placeholder="Seleccione una o varias opciones"
                      :options="doloresOpts"
                      :reduce="option => option"
                      label="text"
                      :multiple="true"
                      taggable
                      @input="newArray => sintomas.dolores = onAddNewOpt(newArray)"
                    />
                  </b-row>

                  <b-row 
                    v-if="sintomas.selected.some(item => item.value === 'hematurias')"
                    class="my-2 ml-1" 
                    align-v="center"
                  >
                    <span class="col-3">Hematuria:</span>
                    <v-select
                      class="col"
                      placeholder="Seleccione una o varias opciones"
                      :options="hematuriasOpts"
                      :reduce="option => option"
                      label="text"
                      taggable
                      :multiple="true"
                      @input="newArray => sintomas.hematurias = onAddNewOpt(newArray)"
                    />
                  </b-row>

                  <b-row
                    v-if="sintomas.selected.some(item => item.value === 'irritativos')"
                    class="my-2 ml-1" 
                    align-v="center"
                  >
                    <span class="col-3">Irritativos:</span>
                    <v-select
                      class="col"
                      placeholder="Seleccione una o varias opciones"
                      :options="irritativosOpts"
                      :reduce="option => option"
                      label="text"
                      taggable
                      :multiple="true"
                      @input="newArray => sintomas.irritativos = onAddNewOpt(newArray)"
                    />
                  </b-row>

                  <b-row
                    v-if="sintomas.selected.some(item => item.value === 'obstructivos')"
                    class="my-2 ml-1" 
                    align-v="center"
                  >
                    <span class="col-3">Obstructivos:</span>
                    <v-select
                      class="col"
                      placeholder="Seleccione una o varias opciones"
                      :options="obstructivosOpts"
                      :reduce="option => option"
                      label="text"
                      taggable
                      :multiple="true"
                      @input="newArray => sintomas.obstructivos = onAddNewOpt(newArray)"
                    />
                  </b-row>

                  <b-row 
                    v-if="sintomas.selected.some(item => item.value === 'disfuncion_sexual')"
                    class="my-2 ml-1" 
                    align-v="center"
                  >
                    <span class="col-3">Disfuncion Sexual:</span>
                    <v-select
                      class="col"
                      placeholder="Seleccione una o varias opciones"
                      :options="disfuncionOpts"
                      :reduce="option => option"
                      label="text"
                      taggable
                      :multiple="true"
                      @input="newArray => sintomas.disfuncion = onAddNewOpt(newArray)"
                    />
                  </b-row>

                </b-card>

              </b-col>
            </b-row>

            <CACV 
              v-if="sintomas.irritativos.some(
                item => item.value === 'incontinencia_urinaria'
              )"
            /> 

          </b-card-body>
        </b-collapse>
      </b-card>
    </b-col>
  </b-row>
   
</template>

<script>
import { mapState }  from 'vuex';
import { addNewOpt } from '@/shared/helpers';
import vSelect  from "vue-select";
import CACV from "./CACV.vue";


export default {
  name: "SemiologiaUrologica",

  components: {
    vSelect,
    CACV
  },

  data() {
    return {
      visibleBody: true,

      sintomas:{
        selected     :[],
        dolores      :[],
        hematurias   :[],
        irritativos  :[],
        obstructivos :[],
        disfuncion   :[],
      },
      

      sintomasOpts:[
        { value:"dolores",              text:"Dolores" },
        { value:"hematurias",           text:"Hematurias" },
        { value:"irritativos",          text:"Irritativos" },
        { value:"obstructivos",         text:"Obstructivos" },
        { value:"disfuncion_sexual",    text:"Disfunción Sexual" },
        { value:"hematospermia",        text:"Hematospermia" },
        { value:"neumaturia",           text:"Neumaturía" },
        { value:"secrecion_uretral",    text:"Secreción uretral" },
        { value:"fiebre_y_escalofrios", text:"Fiebre y escalofrios" },
      ],

      doloresOpts:[
        { value:"lumbar",      text:"lumbar" },
        { value:"suprapubico", text:"suprapubico" },
        { value:"abdominal",   text:"abdominal" },
        { value:"testicular",  text:"testicular" },
        { value:"peneano",     text:"peneano" },
        { value:"perineal",    text:"perineal" },
      ],

      hematuriasOpts:[
        { value:"macroscopica", text:"macroscopica" },
        { value:"microscopica", text:"microscopica" },
      ],

      irritativosOpts:[
        { value:"polaquiuria",                        text:"Polaquiuria" },
        { value:"nocturna",                           text:"Nocturna" },
        { value:"disuria",                            text:"Disuria" },
        { value:"estranguria",                        text:"Estranguria" },
        { value:"sensacion_de_vaciado_imcompleto",    text:"Sensación de vaciado imcompleto" },
        { value:"incontinencia_urinaria",             text:"Incontinencia urinaria" },
        { value:"incontinencia_urinaria_de_esfuerzo", text:"Incontinencia urinaria de esfuerzo" },
        { value:"incontinencia_urinaria_con_urgencia_miccional", text:"Incontinencia urinaria con urgencia miccional" },
        { value:"enuresis",        text:"Enurisis" },
      ],

      obstructivosOpts:[
        { value: 'disminucion_de_la_fuerza_del_flujo_urinario', text: 'Disminucion de la fuerzo del flujo urinario' },
        { value: 'inicio_tardio_de_la_miccion', text: 'Inicio tardio de la miccion' },
        { value: 'chorro_intermitente',         text: 'Chorro intermitente' },
        { value: 'goteo_postmiccional',         text: 'Goteo postmiccional' },
        { value: 'esfuerzo_miccional',          text: 'Esfuerzo miccional' }
      ],

      disfuncionOpts:[
        { value: 'perdida_del_libido',         text: 'Perdida del libido' },
        { value: 'no_logra_mantener_ereccion', text: 'No logra mantener erección' },
        { value: 'erecciones_matutinas',       text: 'Erecciones matutinas' },
        { value: 'incapacidad_para_eyacular',  text: 'Incapacidad para eyacular' },
        { value: 'anorgasmia',                 text: 'Anorgasmia' },
        { value: 'eyaculacion_precoz',         text: 'Eyaculacion precoz' }
      ],
      
    }
  },

  methods: {
    onVisibleBody(value) {
      this.visibleBody = value;
    },

    onAddNewOpt(newArray) {
      return addNewOpt(newArray);
    },

  },

  watch: {
    sintomas: {
      handler(newValue) {
        this.$store.commit("setUrologica", { ...newValue } );
      },
      deep: true
    },


    stSemOtorrino:{
      deep: true,
      handler(newValue){
        const semiologia = { tipo:'urologica', data:newValue }
        this.$store.commit("setSemiologia", semiologia );
      }
    },

  },

  computed: {
    ...mapState({
      stSemOtorrino: state => state.atencionCita.semiologias?.semUrologica,
      stDataDoctor: state => state.atencionCita.dataCita?.doctor
    }),

    esUro(){
      return this.stDataDoctor?.especialidad?.codEsp === '0000000540';
    },
  },

}
</script>
